<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ju0Qjg/tc-custom/9781607054221.jpg?1731155295635" alt="This image is the cover for the book Simply Triangles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Simply Triangles
      </h1>
      <p class="bookDescription body article font2">
        <p>Triangle extravaganza!  Create unique, dynamic designs within pieced triangles, then combine those triangles with other shapes to make sassy stars, daisies, and pinwheels. Add a hexagonal quilt to your repertoire-perfect for a wallhanging or tabletop centerpiece. Whether your palette preference runs to vivid or more muted hues, you'll discover how your color schemes will add a hint of movement to your quilts.    • Create complex-looking designs for any size quilt by combining simple shapes like triangles and diamonds • Learn how to use color and value to make your quilts glow  • Try a variety of skill-building techniques from strip piecing to Y-seams</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barbara H. Cline
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15330ba4